import Swiper, {Navigation} from "swiper";

Swiper.use([Navigation]);

let imageGallerySwiper = null;
let imageControlsSwiper = null;

function initProductView() {
    // Init image gallery swiper
    imageGallerySwiper = new Swiper('.gallery .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        slidesPerView: 1,
        spaceBetween: 0,

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            }
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        on: {
            init: () => {
                document.querySelectorAll('.fade-wall-right,.fade-wall-left').forEach(wallElement => {
                    wallElement.classList.remove('d-none');
                });
            }
        }
    })

    imageControlsSwiper = new Swiper('.image-controls .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,

        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: true,

        on: {
            init: () => {
                document.querySelectorAll('.image-controls .content').forEach(control => {
                    control.onclick = handleImageClick;
                });
            },
            slideChangeTransitionEnd: swiper => {
                toggleImage(swiper.realIndex);
            }
        }
    })
}

function handleImageClick(event){
    const imageElement = event.currentTarget;
    const imageIndex = imageElement.dataset.index;

    toggleImage(imageIndex);
}

function toggleImage(imageIndex) {

    const images = document.querySelectorAll('.product .image > img');

    // Hide all images
    images.forEach(image => {
        image.classList.add('d-none');
    });

    // Show selected image
    images[imageIndex].classList.remove('d-none');

    // Move swiper
    // noinspection JSCheckFunctionSignatures
    imageControlsSwiper.slideTo(imageIndex);
}

export {initProductView}